import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { InsertDriveFile } from '@mui/icons-material';

export default function FileChat({ file }: { file: File | undefined }) {
	const content = useMemo(() => {
		if (!file) return null;

		const style = `w-full max-h-[70vh] rounded`;

		if (file.type?.startsWith('image')) {
			return <img src={URL.createObjectURL(file)} alt={file.name} className={style} />;
		} else if (file.type?.startsWith('video')) {
			return <video src={URL.createObjectURL(file)} className={style} />;
		} else {
			return (
				<Box className={`relative ${style}`}>
					<InsertDriveFile className="h-14 w-14 rounded object-cover text-gray-300" />
					<Typography className={'absolute bottom-1 left-3 right-3 truncate'}>{file.name}</Typography>
				</Box>
			);
		}
	}, [file]);

	return content;
}
